import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/static/icons/chevron-right.svg'
import _imports_1 from '../../static/icons/trash_icon.svg'


const _hoisted_1 = { class: "review-facet-drawer" }
const _hoisted_2 = { class: "review-facet-drawer__page" }
const _hoisted_3 = { class: "review-facet-drawer__header" }
const _hoisted_4 = { class: "review-facet-drawer__title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "review-facet-drawer-page-arrow",
  src: _imports_0
}, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "review-facet-drawer__page-selected-vales"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "review-facet-drawer-page-arrow",
  src: _imports_0
}, null, -1)
const _hoisted_9 = { class: "review-facet-drawer__page" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "review-facet-drawer__title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "review-facet-drawer__remove-all-icon",
  src: _imports_1
}, null, -1)
const _hoisted_14 = { class: "review-facet-drawer__values" }
const _hoisted_15 = {
  key: 0,
  class: "review-facet-drawer__checkbox"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "review-facet-drawer__checkbox-item__count" }
const _hoisted_18 = {
  key: 1,
  class: "review-facet-drawer__checkbox"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "review-facet-drawer__footer" }

import { computed, ref } from 'vue';

import {
  getReviewsContext,
  FacetInformation,
  FacetKeys,
  SortOrderKeys,
} from '@/composables/useReviews';
import useWebsiteText from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewFacetDrawer',
  props: {
    showBackButton: { type: Boolean }
  },
  emits: ['closeDrawer'],
  setup(__props: any, { emit }) {





const { websiteText } = useWebsiteText();
const {
  facets,
  selectedFacets,
  numberOfHits,
  sortingMethod,
  isSortFacetSelected,
  sortOptions,
  addFacet,
  removeFacet,
  setSortingOption,
  removeFacetValues,
  facetDisplayFormatter,
} = getReviewsContext();

const selectedFacetValue = ref<FacetInformation[] | undefined>(undefined);
const selectedFacetKey = ref<FacetKeys | undefined>(undefined);

const sortingMethodLabel = computed(
  () => sortOptions.value.find((s) => s.value === sortingMethod.value)?.label
);

function selectFacet(key?: FacetKeys, facet?: FacetInformation[]) {
  selectedFacetValue.value =
    key === 'productRating'
      ? facet?.sort((a, b) => b.value.localeCompare(a.value))
      : facet;
  selectedFacetKey.value = key;
}

function backToFacetsLabel() {
  clearState();
}

function isFacetValueSelected(key: FacetKeys, value: string) {
  return selectedFacets.value?.[key]?.includes(value);
}

function hasSelectedFacetValues(key: FacetKeys) {
  return selectedFacets.value?.[key]?.length;
}

function isSortingMethodSelected(key: SortOrderKeys) {
  return sortingMethod.value === key;
}

function addOrRemoveFacet(key: FacetKeys, value: string) {
  if (selectedFacets.value?.[key]?.includes(value)) {
    removeFacet(key, value);
    return;
  }
  addFacet(key, value);
}

function closeDrawer() {
  clearState();
  emit('closeDrawer');
}

function selectedFacetValues(key: FacetKeys) {
  return selectedFacets.value?.[key]
    .map((value) => facetDisplayFormatter(key, value))
    .join(', ');
}

function clearState() {
  selectedFacetKey.value = undefined;
  selectedFacetValue.value = undefined;
  isSortFacetSelected.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["review-facet-drawer__container", {
        'review-facet-drawer__container--values':
          selectedFacetValue.value || _unref(isSortFacetSelected),
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(websiteText)('category__facets_all').value), 1)
        ]),
        _createElementVNode("button", {
          class: "review-facet-drawer__page-checkbox clean-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isSortFacetSelected.value = true))
        }, [
          _createElementVNode("div", null, _toDisplayString(_unref(websiteText)('review_sorting').value) + ": " + _toDisplayString(_unref(sortingMethodLabel)), 1),
          _hoisted_5
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(facets), (facetValue, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            (facetValue.length && key !== 'productRating')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "review-facet-drawer__page-checkbox clean-button",
                  onClick: ($event: any) => (selectFacet(key, facetValue))
                }, [
                  _createElementVNode("div", null, _toDisplayString(_unref(websiteText)(`review_${key.toLocaleLowerCase()}`).value), 1),
                  (_unref(selectedFacets)[key]?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(selectedFacetValues(key)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_8
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["review-facet-drawer__header", { 'review-facet-drawer__header--back': __props.showBackButton }])
        }, [
          (__props.showBackButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "review-facet-drawer__back clean-button",
                onClick: backToFacetsLabel
              }, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_12, _toDisplayString(!_unref(isSortFacetSelected)
                ? _unref(websiteText)(`review_${selectedFacetKey.value?.toLocaleLowerCase()}`)
                    .value
                : _unref(websiteText)('review_sorting').value), 1),
          (!_unref(isSortFacetSelected) && hasSelectedFacetValues(selectedFacetKey.value!) )
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "review-facet-drawer__selected-remove-all",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(removeFacetValues)(selectedFacetKey.value!)))
              }, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(_unref(websiteText)('review_reset').value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_14, [
          (!_unref(isSortFacetSelected))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFacetValue.value, (value) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (addOrRemoveFacet(selectedFacetKey.value!, value.value)), ["prevent"]),
                      class: _normalizeClass(["review-facet-drawer__checkbox-item", {
                  'review-facet-drawer__checkbox-item--active': isFacetValueSelected(selectedFacetKey.value!, value.value),
                  'review-facet-drawer__checkbox-item--disabled': value.count <= 0,
                }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_unref(facetDisplayFormatter)(selectedFacetKey.value!, value.value)), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(value.count), 1)
                    ], 10, _hoisted_16)
                  ]))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortOptions), (sort) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_unref(setSortingOption)(sort.value as SortOrderKeys)), ["prevent"]),
                      class: _normalizeClass(["review-facet-drawer__checkbox-item", {
                  'review-facet-drawer__checkbox-item--active': isSortingMethodSelected(sort.value as SortOrderKeys),
                }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(sort.label), 1)
                    ], 10, _hoisted_19)
                  ]))
                }), 256))
              ]))
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        class: "review-facet-drawer__show-reviews primary-button",
        onClick: closeDrawer
      }, _toDisplayString(_unref(numberOfHits) > 1
            ? _unref(websiteText)('review_seereviews', {
                count: _unref(numberOfHits),
              }).value
            : _unref(websiteText)('review_seereview', {
                count: _unref(numberOfHits),
              }).value), 1)
    ])
  ]))
}
}

})